import React from 'react';
import { Trans } from '@lingui/react/macro';

import ClampedParagraph from '@rover/components/src/typography/ClampedParagraph';
import { Flex, Text } from '@rover/kibble/core';
import Avatar from '@rover/kibble/patterns/Avatar';

export type Props = {
  reviewText: string;
  description: string;
  reviewPhotoUrl: string | null;
  reviewerShortName: string;
  defaultAvatar: 'cat' | 'dog';
};

const LINES = 4;

const StaticFeaturedReview: React.FC<Props> = ({
  reviewText,
  description,
  reviewPhotoUrl,
  reviewerShortName,
  defaultAvatar,
}: Props) => {
  const hasReviewText = !!reviewText;
  const hasReviewerName = !!reviewerShortName;

  return (
    <Flex flexDirection="column" gap="1x" flex="1" height="100%">
      {hasReviewText && hasReviewerName ? (
        <>
          <ClampedParagraph lines={LINES}>
            <>&ldquo;{reviewText}&rdquo;</>
          </ClampedParagraph>
          <Flex gap="2x" flexDirection="row" alignItems="center" sx={{ mt: 'auto' }}>
            <Avatar imageUrl={reviewPhotoUrl} type={defaultAvatar} size="small" />
            <Text textAlign="center" textColor="secondary" size="100">
              {reviewerShortName}
            </Text>
          </Flex>
        </>
      ) : (
        <ClampedParagraph lines={LINES}>
          <Trans>About:</Trans> <span itemProp="description">{description}</span>
        </ClampedParagraph>
      )}
    </Flex>
  );
};

export default StaticFeaturedReview;
